
import { HoyaLearningCenterPermissions } from '../../../const';
import { Environment } from '../../../environments';

const ADMIN_PERMISSIONS = [
    HoyaLearningCenterPermissions.READ_COURSE_SEGMENTATION,
    HoyaLearningCenterPermissions.EDIT_COURSE_SEGMENTATION,
];

const SUPER_ADMIN_PERMISSIONS = [
    HoyaLearningCenterPermissions.READ_COURSE_SEGMENTATION,
    HoyaLearningCenterPermissions.EDIT_COURSE_SEGMENTATION,
];

/**
 * Local permissions stored on the webapp. Ideally, we'd never rely on permissions stored
 * inside of the webapp itself and would instead use permissions assigned to Roster users.
 * 
 * Also, these permissions are only on the front-end. If/when the back-end adds permission
 * requirements to the requests, then this will won't work. But that's fine.
 */
const localPermissionGroups = [
    {
        env: Environment.QA,
        name: 'admin-permissions',
        permissions: [ ...ADMIN_PERMISSIONS ],
        personIds: [
            'b9d11153-1812-490e-887c-10fdb4ceb82d',
            // ...
        ],
    },
    {
        env: Environment.QA,
        name: 'super-admin-permissions',
        permissions: [ ...SUPER_ADMIN_PERMISSIONS ],
        personIds: [
            'efdd92f3-1fcb-4752-9708-d4b011bb5f65',
            // ...
        ],
    },
];

export default localPermissionGroups;
